import axios from "axios";
import { supabase } from "../supabaseClient";

// CRM 2.0 Customer Consent › Terms (M1-F6). The server checks the Legal /
// Legal Head permissions; a 400 carries { message, fields: { key: message } }.
const base = () => `${process.env.REACT_APP_PAYMENT_LINK_URL}crm2/consent`;
const auth = () => ({ headers: { Authorization: `Bearer ${supabase.auth.session()?.access_token}` } });

async function getConsentPoints() {
  return (await axios.get(`${base()}/points`, auth())).data.points;
}

async function getConsentTerms(filters = {}) {
  return (await axios.get(`${base()}/terms`, { ...auth(), params: filters })).data.terms;
}

async function getConsentTerm(id) {
  return (await axios.get(`${base()}/terms/${id}`, auth())).data.term;
}

async function createConsentTerm(body) {
  return (await axios.post(`${base()}/terms`, body, auth())).data.term;
}

async function saveConsentTerm(id, body) {
  return (await axios.put(`${base()}/terms/${id}`, body, auth())).data.term;
}

// step: "approve" | "live" | "stop"
async function moveConsentTerm(id, step) {
  return (await axios.post(`${base()}/terms/${id}/${step}`, {}, auth())).data.term;
}

// Ask now table: [{ askGroupId, title, sentTo, holdNextStep, sent, accepted, pending, status, ... }]
async function getConsentAsks() {
  return (await axios.get(`${base()}/asks`, auth())).data.asks;
}

// body: { title, content, how, holdNextStep, projectIds, wingIds, stage, bookingIds } — sent at once
// Returns { askGroupId, bookings, notFound }
async function createConsentAsk(body) {
  return (await axios.post(`${base()}/asks`, body, auth())).data;
}

// filter: { termKey } = all versions of one term; {} = all terms
async function getConsentReport(filter = {}) {
  return (await axios.get(`${base()}/report`, { ...auth(), params: filter })).data.rows;
}

async function getProjectWings(projectId) {
  const { data, error } = await supabase.from("Wings").select("wingId, wingName").eq("projectId", projectId).order("wingName", { ascending: true });
  if (error) throw error;
  return data || [];
}

// Projects switched on for CRM 2.0 (terms can be limited to some of them).
async function getCrm2Projects() {
  const { data, error } = await supabase.from("Projects").select("projectId, projectName").eq("isCrm2", true).order("projectName", { ascending: true });
  if (error) throw error;
  return data || [];
}

function consentError(err) {
  const body = err?.response?.data;
  return { message: body?.message || "Something went wrong, please try again", fields: body?.fields || {} };
}

export {
  getConsentPoints, getConsentTerms, getConsentTerm, createConsentTerm, saveConsentTerm, moveConsentTerm, getCrm2Projects, consentError,
  getConsentAsks, createConsentAsk, getConsentReport, getProjectWings,
};
